import { ApolloProvider } from '@apollo/client';
import { App, ConfigProvider } from 'antd';
import 'antd/dist/reset.css';
import 'containers/Ats/global.css';
import client from 'graphql/client';
import { LogSetup } from 'helpers/utility';
import 'nprogress/nprogress.css';
import React from 'react';
import { Provider } from 'react-redux';
import Profiler from 'symfony-spa-wdt';
import AppThemeProvider from 'components/shared/AppThemeProvider';
import AtsAppHolder from './AtsAppStyle';
import { themeConfig } from './config';
import themes from './config/themes';
import antdTheme from './config/themes/antdTheme';
import './helpers/axiosInterceptor';
import Boot from './redux/boot';
import { history, store } from './redux/store';
import PublicRoutes from './router';

LogSetup();

class AtsApp extends React.Component {
  componentDidMount() {
    const el = document.getElementById('preloader');
    if (!el.classList.contains('done')) {
      el.classList.add('done');
    }
  }

  render() {
    return (
      <React.Fragment>
        <ConfigProvider theme={antdTheme}>
          <App>
            <AppThemeProvider theme={themes[themeConfig.theme]}>
              <AtsAppHolder>
                <Provider store={store}>
                  <ApolloProvider client={client}>
                    <PublicRoutes history={history} />
                  </ApolloProvider>
                </Provider>
              </AtsAppHolder>
            </AppThemeProvider>
          </App>
        </ConfigProvider>
        {import.meta.env.MODE === 'development' && <Profiler />}
      </React.Fragment>
    );
  }
}

Boot()
  .then(() => AtsApp())
  .catch((error) => console.error(error));

export default AtsApp;
